import { forwardRef, LegacyRef } from "react";
import {
  TimePicker as ReactTimePicker,
  type TimePickerProps,
} from "react-time-picker";
import classNames from "classnames";

import styles from "./style.module.scss";

type Props = TimePickerProps & {
  label?: string;
  containerClassName?: string;
  maxDetail?: string;
};

export const TimePicker = forwardRef(function (
  {
    label,
    className,
    containerClassName,
    maxDetail = "second",
    ...rest
  }: Props,
  ref: LegacyRef<any>
) {
  return (
    <div
      className={classNames(styles.container, containerClassName || "")}
      ref={ref}
    >
      {label && <label className={styles.label}>{label}:</label>}
      <ReactTimePicker
        {...rest}
        disableClock
        clearIcon={null}
        maxDetail={maxDetail}
        className={classNames(styles.time_picker, className)}
      />
    </div>
  );
});
